import React, { useEffect } from 'react';
import { useController } from 'react-hook-form';
import Caret from 'components/Icons/Caret';

interface SelectBoxProps {
  labelClass?: string;
  label?: string;
  id: string;
  className?: string;
  wrapperClass?: string;
  defaultSelected?: string;
  helperClass?: string;
  options: {
    id: number;
    value: string;
    name: string;
  }[];
  name: string;
  rules?: any;
  shouldUnregister?: any;
  defaultValue?: any;
  control?: any;
  errorMessage?: string;
  holder?: string;
  disabled?: boolean;
  // eslint-disable-next-line no-unused-vars
  onChangeEvent?(e: string): void;
}

export default function PrescriptionSelectBox({
  label,
  id,
  labelClass,
  className,
  wrapperClass,
  helperClass,
  options,
  name,
  shouldUnregister,
  defaultValue,
  control,
  holder,
  disabled,
  onChangeEvent
}: SelectBoxProps) {
  const { field, fieldState } = useController({
    control,
    name,
    rules: { required: true },
    shouldUnregister,
    defaultValue,
  });

  return (
    <>
      <div
        className={
          'flex px-3 relative flex-col ' + (wrapperClass ? wrapperClass : '')
        }>
        {label && (
          <label
            className={
              'pt-2 select-none rounded-t font-sans ' + labelClass || ''
            }
            htmlFor={id}>
            {label}
          </label>
        )}
        <select
          disabled={disabled}
          {...field}
          className={`pb-3 dresden-select invalid:text-white pt-2 bg-transparent cursor-pointer appearance-none font-sans focus:outline-none ${className ? className : ''
            }`}>
          <option disabled selected hidden>
            {holder ? holder : 'Select'}
          </option>
          {options.map((opt) => (
            <option key={opt.id} value={opt.value}>
              {opt.name}
            </option>
          ))}
        </select>
      </div>
      <p style={{ color: '#d83e3e', fontSize: '70%' }}>
        {fieldState.error ? 'This field is required' : ''}
      </p>
    </>
  );
}
